import React from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';

export const Modal = ({ isOpen, onClose, children, className, size = "md" }) => {
  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const sizeClasses = {
    sm: "max-w-md",
    md: "max-w-2xl",
    lg: "max-w-4xl",
    xl: "max-w-6xl",
    full: "max-w-full mx-4",
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-brand-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div
        className={cn(
          "relative bg-white shadow-luxury-xl w-full animate-scale-in",
          sizeClasses[size],
          className
        )}
      >
        {children}
      </div>
    </div>
  );
};

Modal.displayName = "Modal";

export const ModalHeader = ({ children, onClose, className }) => {
  return (
    <div className={cn("relative p-6 md:p-8 border-b border-brand-black/10", className)}>
      {children}
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-brand-black/50 hover:text-brand-black transition-colors"
          aria-label="Close"
        >
          <X size={24} />
        </button>
      )}
    </div>
  );
};

ModalHeader.displayName = "ModalHeader";

export const ModalTitle = ({ children, className }) => {
  return (
    <h2 className={cn("text-heading-lg font-display pr-8", className)}>
      {children}
    </h2>
  );
};

ModalTitle.displayName = "ModalTitle";

export const ModalDescription = ({ children, className }) => {
  return (
    <p className={cn("text-body-md text-brand-black/60 mt-2", className)}>
      {children}
    </p>
  );
};

ModalDescription.displayName = "ModalDescription";

export const ModalBody = ({ children, className }) => {
  return (
    <div className={cn("p-6 md:p-8", className)}>
      {children}
    </div>
  );
};

ModalBody.displayName = "ModalBody";

export const ModalFooter = ({ children, className }) => {
  return (
    <div className={cn("p-6 md:p-8 pt-0 flex items-center justify-end gap-4", className)}>
      {children}
    </div>
  );
};

ModalFooter.displayName = "ModalFooter";
